<h2 mat-dialog-title>Lista</h2>

<mat-dialog-content>
  <form #form="ngForm" autocomplete="off">
    <div class="p-grid p-fluid">
      <div class="p-md-12 p-float-label">
        <input
          pInputText
          type="text"
          name="name"
          [(ngModel)]="lawyerList.name"
          required />
        <label>Nombre</label>
      </div>

      <div class="p-md-6 p-float-label">
        <p-dropdown
          [options]="alertTypes"
          optionLabel="name"
          optionValue="id"
          filter="true"
          placeholder="----"
          appendTo="body"
          name="alertType"
          [(ngModel)]="lawyerList.alertType">
        </p-dropdown>
        <label>Materia</label>
      </div>

      <div class="p-md-6 p-float-label">
        <p-dropdown
          [options]="judicialDistricts"
          optionLabel="name"
          optionValue="id"
          filter="true"
          placeholder="----"
          appendTo="body"
          name="judicialDistricts"
          [(ngModel)]="lawyerList.judicialDistrict">
        </p-dropdown>
        <label>Partidos judicial</label>
      </div>

     <!--  <div class="p-md-12 p-float-label" *ngIf="availableLawyers.length > 0">
        <p-dropdown
          name="lawyerSelect"
          appendTo="body"
          optionValue="id"
          optionLabel="fullName"
          filter="true"
          placeholder="Añadir abogado/a..."
          [options]="availableLawyers"
          [ngModel]="null"
          (onChange)="onLawyerSelect($event.value)">
        </p-dropdown>
        <label>Abogados/as disponibles</label>
      </div>

      <div class="p-md-12" *ngIf="selectedLawyers.length > 0">
        <label style="display:block; margin-bottom: 0.5rem; font-size: 0.85rem; color: #6c757d;">Abogados/as seleccionados</label>
        <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
          <span
            *ngFor="let lawyer of selectedLawyers"
            class="p-tag p-tag-info"
            style="display: inline-flex; align-items: center; gap: 0.25rem; padding: 0.25rem 0.5rem;">
            {{ lawyer.fullName || (lawyer.name + ' ' + lawyer.lastName) }}
            <button
              type="button"
              pButton
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-sm"
              style="width: 1rem; height: 1rem; padding: 0;"
              (click)="onLawyerRemove(lawyer)">
            </button>
          </span>
        </div>
      </div> -->
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    [disabled]="form.invalid"
    (click)="save()">
    Guardar
  </button>

  <button mat-dialog-close mat-button>Cerrar</button>
</mat-dialog-actions>

<p-toast></p-toast>
